import React, { useEffect, useState } from "react";
import Profilesidebar from "../components/Element/Profilesidebar";
import DocumentRequiredForm from "../components/Element/DocumentRequired/CreateDocumentRequired";
import DocFormUpdateAddress from "../components/Element/DocumentRequired/DocFormUpdateAddress";
// import UploadUpdateAddress from "../components/Element/DocumentRequired/UploadUpdateAddress";
import ProfileSideBarMobile from "../components/Element/ProfileSideBarMobile";
import { isMobileOrLaptop } from "../services/CheckDevice";
const CreateDocumentRequired = (props) => {
  // Check Device - Start
  const [checkDevice, setCheckDevice] = useState("Mobile");

  window.addEventListener("resize", function () {
    // Call the function when the screen size changes
    const deviceType = isMobileOrLaptop();
    setCheckDevice(deviceType);
  });

  useEffect(() => {
    const deviceType = isMobileOrLaptop(350);
    setCheckDevice(deviceType);
  }, []);
  // Check Device - End
  return (
    <React.Fragment>
      <div className="page-content bg-white">
        <div className="content-block">
          <div className="section-full bg-white browse-job p-t50 p-b20">
            <div className="container">
              <div className="row">
                {checkDevice && checkDevice == "Mobile" ? (
                  <ProfileSideBarMobile page="document-required" />
                ) : (
                  <Profilesidebar page="document-required" />
                )}
                <div className="col-xl-9 col-lg-8 m-b30">
                  {window.location.pathname ==
                    "/create-document-update-address" && (
                    <DocFormUpdateAddress></DocFormUpdateAddress>
                  )}
                  {
                    <DocumentRequiredForm
                      setDoc="SetDocumentCompliance"
                      updateDoc="updateDocumentCompliance"
                    />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CreateDocumentRequired;
